import { useState, useEffect } from "react";
import { Menu, X } from "lucide-react";
import { ASSETS } from "@/data/site";

const LINKS = [
  { id: "ueber", label: "Über mich" },
  { id: "leistungen", label: "Leistungen" },
  { id: "werte", label: "Werte" },
  { id: "galerie", label: "Galerie" },
  { id: "stimmen", label: "Stimmen" },
  { id: "kontakt", label: "Kontakt" },
];

const scrollTo = (id) => {
  const el = document.getElementById(id);
  if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
};

export const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (id) => {
    setOpen(false);
    scrollTo(id);
  };

  return (
    <header
      data-testid="site-navbar"
      className={`fixed top-0 inset-x-0 z-50 transition-[background-color,backdrop-filter,border-color,padding] duration-500 ${
        scrolled
          ? "bg-cream/85 backdrop-blur-xl border-b border-gold/20 py-3"
          : "bg-transparent border-b border-transparent py-5"
      }`}
    >
      <nav className="mx-auto max-w-7xl px-6 lg:px-10 flex items-center justify-between">
        <button
          data-testid="nav-logo"
          onClick={() => go("start")}
          className="flex items-center gap-3 group"
        >
          <img src={ASSETS.avatar} alt="Andrea Rauh-Ambros" className="h-11 w-11 rounded-full object-cover object-[50%_25%] ring-1 ring-gold/40" />
          <span className="hidden sm:block text-left leading-tight">
            <span className="block font-serif text-xl text-charcoal">Andrea</span>
            <span className="block text-[10px] uppercase tracking-luxe text-gold-deep">Ästhetik & Heilpraktik</span>
          </span>
        </button>

        <div className="hidden lg:flex items-center gap-9">
          {LINKS.map((l) => (
            <button
              key={l.id}
              data-testid={`nav-link-${l.id}`}
              onClick={() => go(l.id)}
              className="text-sm text-charcoal-soft hover:text-charcoal link-underline"
            >
              {l.label}
            </button>
          ))}
          <button
            data-testid="nav-cta"
            onClick={() => go("kontakt")}
            className="rounded-full bg-charcoal text-gold-soft px-6 py-2.5 text-sm hover:bg-charcoal-soft transition-colors duration-300"
          >
            Termin vereinbaren
          </button>
        </div>

        <button
          data-testid="nav-toggle"
          className="lg:hidden text-charcoal p-2"
          onClick={() => setOpen((o) => !o)}
          aria-label="Menü"
        >
          {open ? <X size={24} /> : <Menu size={24} />}
        </button>
      </nav>

      {open && (
        <div data-testid="mobile-menu" className="lg:hidden bg-cream/95 backdrop-blur-xl border-t border-gold/20 px-6 py-6 flex flex-col gap-4">
          {LINKS.map((l) => (
            <button
              key={l.id}
              data-testid={`mobile-link-${l.id}`}
              onClick={() => go(l.id)}
              className="text-left text-base text-charcoal-soft py-1"
            >
              {l.label}
            </button>
          ))}
          <button
            data-testid="mobile-cta"
            onClick={() => go("kontakt")}
            className="mt-2 rounded-full bg-charcoal text-gold-soft px-6 py-3 text-sm"
          >
            Termin vereinbaren
          </button>
        </div>
      )}
    </header>
  );
};
